import React from 'react';
import { FINANCE_TABS, FINANCE_NAV_TABS } from '../utils/financeTabs';
import StartLockedDepartmentPage from '../components/start/StartLockedDepartmentPage';

/** Locked preview of the portal Finance hub (/portal/finance). */
const FINANCE_UNLOCKS = {
  'labor-burden': { freePage: 'finance/labor-burden', to: '/start/finance/startlaborburden' },
};

const StartFinance = () => (
  <StartLockedDepartmentPage
    title="Finance"
    tabs={FINANCE_NAV_TABS}
    allTabs={FINANCE_TABS}
    unlockMap={FINANCE_UNLOCKS}
  />
);

export default StartFinance;
